/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared quickview snippet. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* Čapkov: jediné místo, které mění množství řádků košíku (drawer i /cart).
   Proč: řádek čepice s návrhem má skryté řádky příplatků (výšivka zadek/bok, barva nitě) spojené podle __capkov_bundle_token.
   Jejich množství MUSÍ vždy rovnat množství hlavního řádku, jinak se příplatky účtují jednou k 4 čepicím (nebo 4× k jedné).
   Co to dělá:
   - zachytí +/−, psaní množství a „Odstranit“ (okno, capture = dřív než staré obslužné skripty), drobné klepání sloučí (300 ms),
   - pošle JEDNO /cart/update.js s mapou {klíč řádku: množství} pro hlavní řádek i všechny jeho příplatky,
   - po odpovědi překreslí jen obsah draweru / stránky z té samé odpovědi (událost cart:change = morph, drawer zůstane otevřený),
   - samoléčba: při načtení, po přidání do košíku a po každé změně opraví rozjetá množství a po prodlevě smaže osiřelé příplatky.
   Názvy vlastností se nemění (cpcaps čte __capkov_* a _capkov_* beze změny). */
(function () {
  "use strict";
  if (window.RDQty) return;
  var DEB = 300, POOLSEC = 'capkov-rd-cart-pool';
  var timers = {}, want = {}, chain = Promise.resolve(), selfEvt = false, keepUntil = 0, lastIntent = 0, addInflight = 0, lastAddAt = 0, orphanSeen = {}, healT = 0;

  function root() { var r = '/'; try { r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { } return r.slice(-1) === '/' ? r : r + '/'; }
  function P(p) { return root() + p; }
  function str(v) { return v == null ? '' : String(v).replace(/^\s+|\s+$/g, ''); }
  function tokOf(pr) { pr = pr || {}; return str(pr.__capkov_bundle_token || pr._capkov_bundle_token || pr.capkov_bundle_token); }
  function isAddon(pr) {
    pr = pr || {};
    var h = str(pr.__capkov_hidden_addon || pr._capkov_hidden_addon).toLowerCase();
    return h === '1' || h === 'true' || h === 'yes' || str(pr.__capkov_addon_type || pr._capkov_addon_type) !== '';
  }
  function enqueue(fn) { var p = chain.then(fn, fn); chain = p.catch(function () { }); return p; }
  function drawer() { return document.getElementById('cart-drawer'); }
  function drawerSec() { var d = drawer(), w = d && d.closest ? d.closest('[id^="shopify-section-"]') : null; return w ? w.id.replace('shopify-section-', '') : ''; }
  function mainSec() { var n = document.querySelector('[data-cap-line-items]'), w = n && n.closest ? n.closest('[id^="shopify-section-"]') : null; return w ? w.id.replace('shopify-section-', '') : ''; }
  function sections() { var s = drawerSec(), m = mainSec(), l = []; if (m) l.push(m); else if (s) l.push(s, POOLSEC); return l.join(','); }   /* na /cart se draweru neukazuje, stačí hlavní sekce (rychlejší odpověď) */
  function invalidate() { try { if (window.RDCart && RDCart.invalidate) RDCart.invalidate(); } catch (e) { } }

  var lastCart = null, lastCartAt = 0, known = {}, busyT = {}, MAXQ = 99, NET = 8000;
  var EN = /^en/i.test(String((window.Shopify && Shopify.locale) || document.documentElement.lang || ''));
  var TXT = EN ? { stock: rdOT("we_only_have_n_in_stock_096cfd0", "We only have {n} in stock"), max: rdOT("maximum_n_per_order_3a2da0d", "Maximum {n} per order"), min: rdOT("minimum_is_1_use_remove_to_delete_the_item_b9c82a1", "Minimum is 1. Use Remove to delete the item."), lost: rdOT("we_could_not_restore_the_embroidery_add_ons_so_t_a083412", "We could not restore the embroidery add-ons, so the design was removed from your cart. Please add it again."), gen: rdOT("could_not_change_the_quantity_the_cart_was_refre_6c1b675", "Could not change the quantity, the cart was refreshed. Try again."), net: rdOT("connection_problem_the_cart_was_refreshed_a051326", "Connection problem, the cart was refreshed.") }
    : { stock: rdOT("we_only_have_n_in_stock_096cfd0", "We only have {n} in stock"), max: rdOT("maximum_n_per_order_3a2da0d", "Maximum {n} per order"), min: rdOT("minimum_is_1_use_remove_to_delete_the_item_b9c82a1", "Minimum is 1. Use Remove to delete the item."), lost: rdOT("we_could_not_restore_the_embroidery_add_ons_so_t_a083412", "We could not restore the embroidery add-ons, so the design was removed from your cart. Please add it again."), gen: rdOT("could_not_change_the_quantity_the_cart_was_refre_6c1b675", "Could not change the quantity, the cart was refreshed. Try again."), net: rdOT("connection_problem_the_cart_was_refreshed_a051326", "Connection problem, the cart was refreshed.") };
  function T(k, n) { return String(TXT[k]).replace('{n}', n); }
  function timeout(p, ms) { return new Promise(function (res, rej) { var t = setTimeout(function () { rej(Object.assign(new Error('timeout'), { net: true })); }, ms); p.then(function (v) { clearTimeout(t); res(v); }, function (e) { clearTimeout(t); rej(e); }); }); }
  function remember(cart) { try { (cart.items || []).forEach(function (it) { known[it.key] = Number(it.quantity) || 0; }); } catch (e) { } }
  function getCart() {
    if (lastCart && Date.now() - lastCartAt < 4000 && lastAddAt <= lastCartAt && !addInflight) return Promise.resolve(lastCart);   /* vlastní poslední odpověď, ušetří dotaz */
    invalidate();
    return timeout(fetch(P('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }), NET).then(function (c) { remember(c); return c; });
  }
  function getCartFresh() { lastCartAt = 0; return getCart(); }
  function postUpdate(updates) {
    var body = { updates: updates }, s = sections(); if (s) body.sections = s;
    invalidate();
    return timeout(fetch(P('cart/update.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (r.ok) { lastCart = j; lastCartAt = Date.now(); remember(j); } if (!r.ok) { var e = new Error((j && (j.description || j.message)) || 'update'); e.status = r.status; throw e; } return j; }); }), NET);
  }

  /* co se má změnit, aby množství příplatků = množství hlavního řádku (součet hlavních se stejným tokenem) */
  function computeFix(items, removeOrphans) {
    var main = {}, ups = {}, orph = [], any = false, i, it, t;
    for (i = 0; i < items.length; i++) { it = items[i]; t = tokOf(it.properties); if (t && !isAddon(it.properties)) main[t] = (main[t] || 0) + (Number(it.quantity) || 0); }
    for (i = 0; i < items.length; i++) {
      it = items[i]; t = tokOf(it.properties);
      if (!t || !isAddon(it.properties)) continue;
      if (main[t] == null) { orph.push(it.key); if (removeOrphans) { ups[it.key] = 0; any = true; } continue; }
      if ((Number(it.quantity) || 0) !== main[t]) { ups[it.key] = main[t]; any = true; }
    }
    return { updates: ups, any: any, orphans: orph };
  }

  /* ---------- zobrazení ---------- */
  function rowOf(n) { return n && n.closest ? n.closest('line-item[data-line-key], tr[data-line-key], [data-cap-line-row][data-line-key]') : null; }
  function rowsByKey(key) {
    var out = [], all = document.querySelectorAll('[data-line-key]'), i;
    for (i = 0; i < all.length; i++) { if (all[i].getAttribute('data-line-key') === key && /^(LINE-ITEM|TR)$/.test(all[i].nodeName)) out.push(all[i]); }
    return out;
  }
  function inputsOf(row) { return row ? [].slice.call(row.querySelectorAll('input.quantity-input')) : []; }
  function setBusy(key, on) {
    clearTimeout(busyT[key]); if (on) busyT[key] = setTimeout(function () { if (!want[key] && !timers[key] && !flushing) { setBusy(key, false); setBtns(key, false); ensure(); } }, 20000);
    rowsByKey(key).forEach(function (r) { r.classList.toggle('rdq-busy', !!on); if (on) r.setAttribute('aria-busy', 'true'); else r.removeAttribute('aria-busy'); });
  }
  function setBtns(key, off) {
    rowsByKey(key).forEach(function (r) {
      [].forEach.call(r.querySelectorAll('.qty-btn,[data-cap-qty-dec],[data-cap-qty-inc]'), function (b) {
        b.classList.toggle('rdq-btn-off', !!off); if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
    });
  }
  function showErr(key, msg) {
    if (!msg) return;
    var until = Date.now() + 6000;
    function put() {
      rowsByKey(key).forEach(function (r) {
        var old = r.querySelector('.rdq-err'); if (old && old.textContent === msg) return; if (old) old.remove();
        var p = document.createElement('div'); p.className = 'rdq-err'; p.setAttribute('role', 'alert'); p.textContent = msg;
        var host = r.querySelector('.line-item__info') || r.querySelector('td') || r; host.appendChild(p);
      });
    }
    function loop() { if (Date.now() > until) { rowsByKey(key).forEach(function (r) { var o = r.querySelector('.rdq-err'); if (o) o.remove(); }); return; } put(); setTimeout(loop, 400); }   /* po překreslení řádku se zpráva vrátí */
    loop();
  }
  function broadcast(cart) {
    selfEvt = true;
    try {
      /* /cart: překreslení z téže odpovědi (bez dalšího dotazu a čekání) */
      var C = window.__CAP_MAIN_CART_CTRL, ms = mainSec();
      if (C && ms && cart && cart.sections && cart.sections[ms] && typeof C.applyFragmentsFromHTML === 'function') {
        if (!C.__rdqQuiet) { C.__rdqQuiet = 1; var ss = C.syncSoon; C.syncSoon = function () { if (selfEvt) return; return ss.apply(this, arguments); }; var fu = C.fsUpdateFromCartJS; C.fsUpdateFromCartJS = function () { if (selfEvt) return; return fu.apply(this, arguments); }; }
        try { C.applyFragmentsFromHTML(cart.sections[ms]); if (typeof C.fsRender === 'function' && typeof cart.total_price === 'number') C.fsRender(cart.total_price, { updating: true, force: true }); } catch (e) { }
      }
      if (!cart || !cart.sections) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      else document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'rd:qty', cart: cart } }));
    } finally { selfEvt = false; }
  }
  function keep(ms) { keepUntil = Math.max(keepUntil, Date.now() + ms); }

  /* ---------- změna množství ---------- */
  function pending() { return Object.keys(timers).length > 0 || Object.keys(want).length > 0; }
  var flushing = false;
  function digits(str) { var m = String(str || '').match(/\d+/g); return m ? m : []; }
  function recover(keys, batch, err) {
    /* vždy z reálného košíku: příplatky podle hlavního řádku, zpráva pod řádkem, nikdy ne napůl použitý stav */
    var stockMax = 0, status = err && err.status, msgKey = (err && err.net) || !status ? 'net' : 'gen';
    if (status === 422 || status === 400) { var ns = digits(err.message).map(Number).filter(function (n) { return n >= 1 && n < 1000; }); if (ns.length) { stockMax = ns[0]; msgKey = 'stock'; } }
    return getCartFresh().then(function (cart) {
      var items = cart.items || [], ups = {}, by = {}; items.forEach(function (it) { by[it.key] = it; });
      var sim = items.map(function (it) { var q = it.quantity; if (stockMax && batch[it.key] != null && by[it.key]) q = Math.min(batch[it.key], stockMax); return { key: it.key, quantity: q, properties: it.properties }; });
      if (stockMax) keys.forEach(function (k) { if (by[k]) { var q = Math.min(batch[k], stockMax); if (q !== by[k].quantity) ups[k] = q; } });
      var fix = computeFix(sim, true); Object.keys(fix.updates).forEach(function (k) { ups[k] = fix.updates[k]; });
      keys.forEach(function (k) { showErr(k, stockMax ? T('stock', stockMax) : T(msgKey)); });
      return timeout(postUpdate(ups), NET).catch(function () { return getCartFresh(); });
    }).then(function (cart) { broadcast(cart && cart.items && !cart.sections ? Object.assign({}, cart) : cart); return cart; })
      .catch(function () { keys.forEach(function (k) { showErr(k, T('net')); }); invalidate(); try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { } });
  }
  function flush() {
    return enqueue(function () {
      var batch = {}, keys = Object.keys(want).filter(function (k) { return !timers[k]; });
      if (!keys.length) return null;
      keys.forEach(function (k) { batch[k] = want[k]; delete want[k]; });
      keys.forEach(function (k) { setBusy(k, true); setBtns(k, true); });
      keep(4000); flushing = true;
      return getCart().then(function (cart) {
        var items = cart.items || [], ups = {}, sim = items.map(function (it) { return { key: it.key, quantity: batch[it.key] != null ? batch[it.key] : it.quantity, properties: it.properties }; });
        var kn = {}; items.forEach(function (it) { kn[it.key] = it; });
        keys.forEach(function (k) { if (kn[k]) ups[k] = batch[k]; });
        var fix = computeFix(sim, true);
        Object.keys(fix.updates).forEach(function (k) { ups[k] = fix.updates[k]; });
        if (!Object.keys(ups).length) return cart;
        return postUpdate(ups);
      }).then(function (cart) {
        if (!pending()) broadcast(cart);
        return cart;
      }).catch(function (err) {
        return recover(keys, batch, err);
      }).then(function () {
        flushing = false;
        keys.forEach(function (k) { if (!want[k] && !timers[k]) { setBusy(k, false); setBtns(k, false); } });
        keep(900);
        if (Object.keys(want).some(function (k) { return !timers[k]; })) return flush();
      });
    });
  }
  function setQty(key, qty, immediate) {
    want[key] = qty; setBusy(key, true);
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { delete timers[key]; flush(); }, immediate ? 0 : DEB);
    keep(DEB + 4000);
  }

  function clampQty(input, v) {
    var min = parseInt(input.getAttribute('min') || '1', 10), max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity; if (!isFinite(max) || max > MAXQ) max = MAXQ;
    if (!isFinite(min) || min < 1) min = 1;
    if (v < min) v = min; if (isFinite(max) && v > max) v = max;
    return v;
  }
  function showQty(row, v) { inputsOf(row).forEach(function (i) { i.value = String(v); }); }

  function onClick(e) {
    var t = e.target, d = drawer();
    /* úmysl zavřít drawer (křížek ve shadow DOM = target je hostitel, klik mimo, Esc řeší keydown) */
    if (d && t && (t === d || (t.nodeType === 1 && document.contains(t) && !d.contains(t)))) lastIntent = Date.now();
    if (!t || !t.closest) return;
    var rm = t.closest('a[href*="/cart/change"], [data-cap-remove]');
    var btn = !rm ? t.closest('.quantity-stepper .qty-btn, [data-cap-qty-dec], [data-cap-qty-inc]') : null;
    if (!rm && !btn) return;
    var row = rowOf(rm || btn); if (!row || row.closest('[data-rdc-fcline]') || row.hasAttribute('data-rdc-fcline')) return;
    var key = row.getAttribute('data-line-key'); if (!key) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if ((btn && btn.getAttribute('aria-disabled') === 'true') || (rm && row.classList.contains('rdq-busy') && want[key] === 0)) return;
    if (rm) { showQty(row, 0); setQty(key, 0, true); return; }
    var input = row.querySelector('input.quantity-input'); if (!input) return;
    var step = parseInt(input.getAttribute('step') || '1', 10) || 1;
    var dir = (btn.getAttribute('data-d') === '1' || btn.hasAttribute('data-cap-qty-inc')) ? 1 : -1;
    var cur = want[key] != null ? want[key] : (parseInt(input.value, 10) || 1);
    var next = clampQty(input, cur + dir * step);
    if (dir > 0 && next === cur) { showErr(key, hintFor(input, key, cur + step) || ''); return; }
    if (next === cur && want[key] == null) return;
    showQty(row, next); setQty(key, next);
  }
  function hintFor(t, key, v) {
    var max = t.getAttribute('max') ? parseInt(t.getAttribute('max'), 10) : Infinity; if (!isFinite(max) || max > MAXQ) max = MAXQ;
    if (v > max) return max === MAXQ ? T('max', max) : T('stock', max);
    if (v < 1) return T('min');
    return '';
  }
  function onType(e) {
    var t = e.target; if (!t || !t.matches || !t.matches('input.quantity-input')) return;
    var row = rowOf(t); if (!row || row.hasAttribute('data-rdc-fcline') || (row.closest && row.closest('[data-rdc-fcline]'))) return;
    var key = row.getAttribute('data-line-key'); if (!key) return;
    e.stopImmediatePropagation();
    if (e.type === 'input') return;   /* při psaní se nic neposílá ani neořezává; až po opuštění pole / Enter */
    var mm = String(t.value).match(/^\s*(\d+)/), v = mm ? parseInt(mm[1], 10) : NaN, cur = want[key] != null ? want[key] : (known[key] || parseInt(t.defaultValue, 10) || 1);
    if (!isFinite(v)) { showQty(row, cur); return; }
    var hint = hintFor(t, key, v); v = clampQty(t, v);
    showQty(row, v); if (hint) showErr(key, hint);
    if (v !== cur || want[key] != null) setQty(key, v);
  }
  window.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('input.quantity-input')) { e.preventDefault(); e.target.blur(); } }, true);
  window.addEventListener('click', onClick, true);
  window.addEventListener('input', onType, true);
  window.addEventListener('change', onType, true);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') lastIntent = Date.now(); }, true);
  window.addEventListener('dialog:force-close', function () { lastIntent = Date.now(); }, true);

  /* změna množství nesmí zavřít drawer (klik na tlačítko, které se během překreslení odpojí, ho jinak bere jako klik mimo) */
  function guardDrawer() {
    var d = drawer(); if (!d || d.__rdqGuard || typeof d.hide !== 'function') return; d.__rdqGuard = 1;
    var h = d.hide;
    d.hide = function () {
      if (Date.now() < keepUntil && Date.now() - lastIntent > 700) return Promise.resolve();
      return h.apply(this, arguments);
    };
  }

  /* ---------- samoléčba ---------- */

  /* ---------- F7: chybějící řádky příplatků (z vlastností hlavního řádku _capkov_addons_json) ---------- */
  var missSeen = {}, tried = {}, VKEY = 'rdq_addon_vids';
  function lsGet() { try { return JSON.parse(localStorage.getItem(VKEY) || '{}') || {}; } catch (e) { return {}; } }
  function lsPut(m) { try { localStorage.setItem(VKEY, JSON.stringify(m)); } catch (e) { } }
  function lowC(s) { return str(s).toLowerCase(); }
  function addonKey(pr) {
    var ty = str(pr.__capkov_addon_type);
    if (ty === 'thread_color') return 'color:' + lowC(pr.__capkov_addon_color);
    if (ty === 'placement') return 'pl:' + str(pr.__capkov_addon_placement);
    return '';
  }
  /* variant příplatku si pamatujeme z každého přečteného košíku (stejný typ/umístění/barva = stejná varianta) */
  function learnAddons(items) {
    var m = lsGet(), ch = false;
    (items || []).forEach(function (it) { var pr = it.properties || {}; if (!isAddon(pr) || !it.variant_id) return; var k = addonKey(pr); if (k && m[k] !== it.variant_id) { m[k] = it.variant_id; ch = true; } if (str(pr.__capkov_addon_placement) === 'back' || str(pr.__capkov_addon_type) !== 'placement') return; if (/^side_/.test(str(pr.__capkov_addon_placement)) && m['pl:side'] !== it.variant_id) { m['pl:side'] = it.variant_id; ch = true; } });
    if (ch) lsPut(m);
  }
  function expectedOf(m) {
    var j; try { j = JSON.parse(m.properties && m.properties._capkov_addons_json); } catch (e) { return null; }
    if (!j || typeof j !== 'object') return null;
    var out = [], tm = j.thread_colors || {}, fees = j.placement_fees || {};
    (j.paid_placements || []).forEach(function (p) { out.push({ ty: 'placement', pl: p, fee: fees[p] != null ? fees[p] : j.placement_fee }); });
    (j.paid_thread_colors || []).forEach(function (c) { var pls = Object.keys(tm).filter(function (p) { return lowC(tm[p]) === lowC(c); }); out.push({ ty: 'thread_color', color: c, pls: pls, fee: j.color_fee }); });
    return out;
  }
  function hasAddon(list, e) { return (list || []).some(function (a) { var pr = a.properties || {}; return e.ty === 'thread_color' ? (str(pr.__capkov_addon_type) === 'thread_color' && lowC(pr.__capkov_addon_color) === lowC(e.color)) : (str(pr.__capkov_addon_type) === 'placement' && str(pr.__capkov_addon_placement) === e.pl); }); }
  function variantFor(e, tok) {
    var k = e.ty === 'thread_color' ? 'color:' + lowC(e.color) : 'pl:' + e.pl, m = lsGet(), v = m[k];
    if (!v && e.ty === 'placement' && /^side_/.test(e.pl)) v = m['pl:side'];
    try {
      var raw = sessionStorage.getItem('capkov_extras:' + tok), pl = raw && JSON.parse(raw);
      ((pl && pl.items) || []).forEach(function (x) { var pr = x.properties || {}; if (!v && addonKey(pr) === k) v = x.id; });
    } catch (x) { }
    return v ? Number(v) : 0;
  }
  function propsFor(e, tok) {
    var pr = { __capkov_hidden_addon: '1', __capkov_bundle_token: tok, __capkov_addon_type: e.ty, __capkov_addon_fee: String(e.fee == null ? '' : e.fee) };
    if (e.ty === 'thread_color') { pr.__capkov_addon_color = String(e.color); pr.__capkov_addon_placements = (e.pls || []).join(','); } else pr.__capkov_addon_placement = e.pl;
    return pr;
  }
  /* co chybí: přidat (zdroj varianty známý) nebo celý návrh odebrat (zdroj neznámý); nikdy hlavní řádek bez příplatků */
  function repairMissing(items, now) {
    var mains = {}, have = {}, res = { add: [], drop: [], pending: false }, seenNow = {};
    learnAddons(items);
    items.forEach(function (it) { var t = tokOf(it.properties); if (!t) return; if (isAddon(it.properties)) (have[t] = have[t] || []).push(it); else (mains[t] = mains[t] || []).push(it); });
    Object.keys(mains).forEach(function (t) {
      var exp = expectedOf(mains[t][0]); if (!exp || !exp.length) return;
      var qty = 0; mains[t].forEach(function (m) { qty += Number(m.quantity) || 0; });
      var miss = exp.filter(function (e) { return !hasAddon(have[t], e); }); if (!miss.length || qty < 1) return;
      seenNow[t] = 1; if (!missSeen[t]) missSeen[t] = now;
      if (now - missSeen[t] < 2500 || addInflight || now - lastAddAt < 2500) { res.pending = true; return; }
      var adds = [], ok = tried[t] == null || tried[t] < 2;
      if (ok) miss.forEach(function (e) { var v = variantFor(e, t); if (!v) ok = false; else adds.push({ id: v, quantity: qty, properties: propsFor(e, t) }); });
      if (ok) { tried[t] = (tried[t] || 0) + 1; res.add = res.add.concat(adds); }
      else mains[t].concat(have[t] || []).forEach(function (it) { res.drop.push(it.key); });
    });
    for (var k in missSeen) if (!seenNow[k]) delete missSeen[k];
    return res;
  }
  function note(msg) {
    try {
      var e = document.createElement('div'); e.setAttribute('role', 'alert'); e.textContent = msg;
      e.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:100010;max-width:min(92vw,460px);background:#111;color:#fff;padding:12px 16px;border-radius:12px;font:600 14px/1.4 system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.25)';
      document.body.appendChild(e); setTimeout(function () { e.remove(); }, 7000);
    } catch (x) { }
  }
  function addAddons(list) {
    return timeout(fetch(P('cart/add.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Capkov-Skip-Extras': '1' }, body: JSON.stringify({ items: list }) }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }), NET);
  }
  var healBusy = null;
  function ensure() {
    if (healBusy) return healBusy;
    healBusy = enqueue(function () {
      if (pending()) return { changed: false, cart: null };
      return getCart().then(function (cart) {
        var now = Date.now(), items = cart.items || [], fix = computeFix(items, false), ups = {}, k, seen = {};
        Object.keys(fix.updates).forEach(function (x) { ups[x] = fix.updates[x]; });
        fix.orphans.forEach(function (key) {
          seen[key] = 1; if (!orphanSeen[key]) orphanSeen[key] = now;
          if (now - orphanSeen[key] >= 1500 && !addInflight && now - lastAddAt >= 1500) ups[key] = 0;
        });
        for (k in orphanSeen) if (!seen[k]) delete orphanSeen[k];
        if (fix.orphans.length) scheduleHeal(1800);
        var rep = repairMissing(items, now); if (rep.pending) scheduleHeal(2700);
        rep.drop.forEach(function (key) { ups[key] = 0; });
        if (!Object.keys(ups).length && !rep.add.length) return { changed: false, cart: cart };
        var step = Object.keys(ups).length ? postUpdate(ups) : Promise.resolve(cart);
        return step.then(function (c2) {
          if (!rep.add.length) return c2;
          return addAddons(rep.add).then(function () { return getCartFresh(); }, function () { scheduleHeal(2500); return c2; });
        }).then(function (c2) { if (rep.drop.length) note(TXT.lost); broadcast(c2); return { changed: true, cart: c2 }; });
      }).catch(function () { return { changed: false, cart: null }; });
    }).then(function (r) { healBusy = null; return r; }, function () { healBusy = null; return { changed: false, cart: null }; });
    return healBusy;
  }
  function scheduleHeal(ms) { clearTimeout(healT); healT = setTimeout(function () { ensure(); }, ms); }
  window.__CAPKOV_ENSURE_ADDON_SYNC = ensure;

  ['cart:change', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { if (!selfEvt) scheduleHeal(350); }); });

  /* po přidání do košíku (příplatky se někdy přidávají druhým dotazem) */
  if (typeof window.fetch === 'function') {
    var f0 = window.fetch;
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url) || '', m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (m === 'POST' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(u)) lastCartAt = 0;   /* cizí změna košíku = mezipaměť neplatí */
      if (m === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(u)) {
        addInflight++;
        var done = function () { addInflight = Math.max(0, addInflight - 1); lastAddAt = Date.now(); scheduleHeal(700); setTimeout(function () { ensure(); }, 2000); };
        var p = f0.apply(this, arguments); p.then(done, done); return p;
      }
      return f0.apply(this, arguments);
    };
  }

  function boot() { guardDrawer(); setTimeout(function () { guardDrawer(); ensure(); }, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('dialog:after-show', guardDrawer);

  window.RDQty = { set: function (key, qty) { setQty(key, qty); }, remove: function (key) { setQty(key, 0, true); }, ensure: ensure, computeFix: computeFix };
})();

})();
